import PeriodEdit from '@/components/modals/periodEdit'
import ConfirmModal from '@/components/modals/confirmModal'

import { mapMutations, mapGetters, mapActions } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import moment from 'moment'

export default {
  components: {
    PeriodEdit,
    ConfirmModal
  },
  props: [
    'isDialogOpen'
  ],
  data () {
    return {
      isConfirmModalOpen: false,
      isPeriodManagementModalOpen: false,
      isLoadingPeriods: false,
      periodTableHeaders: [
        { text: 'Data Inicial', value: 'startperiod' },
        { text: 'Data Final', value: 'endperiod' },
        { text: 'Código do contrato', value: 'codcontract' },
        { text: 'Número de licenças', value: 'licenses' },
        { text: 'Tipo de contrato', value: 'idaccounttype' },
        { text: 'Status', value: 'active' },
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      periodTableFooter: {
        'items-per-page-text': 'Registros por página',
        'items-per-page-options': [5, 10, 15, -1],
        'items-per-page-all-text': 'Todos'
      }
    }
  },
  mounted () {
    this.getTypes()
  },
  methods: {
    ...mapMutations([
      'CLEAR_SELECTED_MAINTAINER',
      'SET_SELECTED_PERIOD',
      'CLEAR_SELECTED_PERIOD'
    ]),
    ...mapActions({
      addToast: ADD_TOAST_MESSAGE
    }),
    ...mapActions([
      'actionGetMaintainerPeriods',
      'actionGetAllClients',
      'actionLinkClientToMaintainer',
      'actionGetTypes',
      'actionDeleteMaintainerPeriod'
    ]),
    getTypes () {
      this.isLoadingPeriods = true

      this.actionGetTypes()
        .then(() => {
          this.isLoadingPeriods = false
        })
        .catch(() => {
          this.isLoadingPeriods = false
        })
    },
    editPeriod (period) {
      period.endperiod = moment(period.endperiod).utc(0).format('YYYY-MM-DD')
      period.startperiod = moment(period.startperiod).utc(0).format('YYYY-MM-DD')

      this.SET_SELECTED_PERIOD(period)

      this.isPeriodManagementModalOpen = true
    },
    addNewPeriod () {
      this.isPeriodManagementModalOpen = true
    },
    deletePeriod () {
      this.isLoadingPeriods = true

      const params = {
        accountId: this.getterSelectedPeriod.idaccount,
        periodId: this.getterSelectedPeriod.id
      }

      this.actionDeleteMaintainerPeriod(params)
        .then((response) => {
          this.addToast({
            text: response.message,
            type: 'success'
          })

          this.isLoadingPeriods = false
          this.closeConfirmModal()
        })
        .catch((e) => {
          this.addToast({
            text: e.message || e,
            type: 'danger'
          })

          this.isLoadingPeriods = false
          this.closeConfirmModal()
        })
    },
    closePeriodDialog () {
      this.CLEAR_SELECTED_MAINTAINER()
      this.$emit('emit-close-dialog')
    },
    dateFormatted (date) {
      return moment(date).utc(0).format('DD/MM/YYYY')
    },
    returnAccountType (typeId) {
      const typeText = this.getterRegistrationTypes.find((val) => {
        return val.id === typeId
      })

      if (typeText !== -1) {
        return typeText.name
      }
    },
    openConfirmModal (period) {
      this.isConfirmModalOpen = true
      this.SET_SELECTED_PERIOD(period)
    },
    closeConfirmModal () {
      this.CLEAR_SELECTED_PERIOD()
      this.isConfirmModalOpen = false
    }
  },
  computed: {
    ...mapGetters([
      'getterSelectedMaintainer',
      'getterSelectedPeriod',
      'getterRegistrationTypes'
    ])
  },
  destroyed () {
    document.querySelector('body').classList.remove('overflow-y-hidden')
  }
}
